var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualitycheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 64,
    viewBox: "0 0 56 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6184 1.5C39.5842 1.50002 41.1779 3.1088 41.178 5.09333C41.178 7.07788 39.5842 8.68664 37.6184 8.68666H35.1011C34.7176 8.68666 34.4063 9.00072 34.4063 9.38795V24.773C34.4063 25.8271 34.7201 26.8576 35.307 27.7294L53.0774 51.5476C56.2108 56.2026 52.9085 62.4996 47.3336 62.4997H8.45679C2.88189 62.4996 -0.42043 56.2026 2.71294 51.5476L20.4833 27.7294C21.0702 26.8576 21.3841 25.8271 21.3841 24.773V9.38795C21.3841 9.00072 21.0728 8.68666 20.6892 8.68666H18.172C16.2062 8.68666 14.6124 7.07789 14.6124 5.09333C14.6124 3.10878 16.2062 1.5 18.172 1.5H37.6184Z",
    stroke: "#7D96AB",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71503 51.5471C-0.418705 56.2022 2.88407 62.4996 8.45921 62.4996L44.6393 57.5828C47.2383 57.2296 48.5265 54.2072 46.9936 52.0592L30.9403 29.5646C30.0885 28.371 29.6302 26.9372 29.6302 25.4661V1.50004L18.1741 1.5C16.2083 1.5 14.6147 3.10881 14.6147 5.09337C14.6147 7.07793 16.2083 8.68674 18.1741 8.68674H20.6918C21.0753 8.68674 21.3863 9.00065 21.3863 9.38788V24.7728C21.3863 25.827 21.0725 26.8569 20.4856 27.7287L2.71503 51.5471Z",
    fill: "#EBFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3092 27.7287C34.7223 26.8569 34.4085 25.827 34.4085 24.7728V9.38788C34.4085 9.00065 34.7194 8.68674 35.103 8.68674H37.6206C39.5864 8.68672 41.18 7.07792 41.18 5.09337C41.18 3.10882 39.5864 1.50002 37.6206 1.5L29.6302 1.50004V25.4661C29.6302 26.9372 30.0885 28.371 30.9403 29.5646L46.9936 52.0592C48.5265 54.2072 47.2383 57.2296 44.6393 57.5828L8.45921 62.4996H47.3356C52.9107 62.4996 56.2135 56.2022 53.0798 51.5471L35.3092 27.7287Z",
    fill: "#C5E4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71565 51.5477C-0.41806 56.2028 2.8847 62.5002 8.45983 62.5002H47.3362C52.9113 62.5002 56.2141 56.2028 53.0804 51.5477L45.3514 41.7085C22.6928 41.7085 23.4669 31.1241 13.8304 37.0837L2.71565 51.5477Z",
    fill: "#F88F14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71565 51.5466C-0.41806 56.2017 2.8847 62.4991 8.45983 62.4991H47.3362C52.9113 62.4991 56.2141 56.2017 53.0804 51.5466L42.1459 36.8535C31.4864 41.0673 25.4636 51.5466 6.54513 46.4139L2.71565 51.5466Z",
    fill: "#FCC214"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualitycheck);
export default __webpack_public_path__ + "static/media/qualitycheck.e52dcd51e4750d5cfc5731ce5bfdd51a.svg";
export { ForwardRef as ReactComponent };